import { isDate } from 'lodash';
import { formatISO, format } from 'date-fns';
import { getInitialLocale } from '../i18n';
import getDateFnsLocale from './getDateFnsLocale';

const defaultLocale = getInitialLocale();

export const formatDate = (date, tokens, locale = defaultLocale) => {
  const dateFnsLocale = getDateFnsLocale(locale);

  if (!date) return '';

  if (isDate(date)) {
    return format(date, tokens, {
      locale: dateFnsLocale,
    });
  }

  return format(new Date(date), tokens, { locale: dateFnsLocale });
};

export const formatISODate = (date, tokens, locale = defaultLocale) => {
  const dateFnsLocale = getDateFnsLocale(locale);

  if (isDate(date)) {
    return formatISO(date, tokens, {
      locale: dateFnsLocale,
    });
  }

  return formatISO(new Date(date), tokens, { locale: dateFnsLocale });
};
